import React from "react";
import "./Container.scss";

import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { DNDItem } from "components/DND";

const Container = ({ children, onDragEnd, id }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={id}>
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {children.map((child, i) => {
              return (
                <DNDItem key={i} index={i}>
                  {child}
                </DNDItem>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default Container;
